import { database } from './config';
import ErrorLog from './error';
const Error = new ErrorLog()

export default class Categoria {
    constructor() {
        this.Descripcion = ''
        this.Activo = true
        this.captionText = ''
    }

    guardar(categoria) {
        // this.db.collection('post').doc('key').set({})
        return database.collection('categorias').doc().set({
            ...categoria
        })
            .then()
            .catch(error => console.error(Error.guardarError(error)))
    }

    eliminar(id) {
        return new Promise((resolve, reject) => {
            database.collection("categorias")
                .doc(id)
                .delete()
                .then(result => resolve(result))
                .catch(error => reject(Error.guardarError(error)))
        })
    }


    getCategorias() {
        return new Promise((resolve, reject) => {
            database.collection('categorias')
                .get()
                .then(querySnapshot => resolve(querySnapshot.docs))
                .catch(error => reject(Error.guardarError(error)))
        })
    }

    getCategoria(params) {
        return new Promise((resolve, reject) => {
            database.collection('categorias')
                .where('Descripcion_lower', '==', params.Descripcion)
                .get()
                .then(function (querySnapshot) {
                    querySnapshot.forEach(function (doc) {
                        resolve(doc.data())
                    })
                })
                .catch(error => reject(Error.guardarError(error)))
        })
    }

}